import { isFunction } from "lodash";
import { SetStateAction } from "react";

export const getUpd = <T>(upd: SetStateAction<T>, curr: T): T => {
  return isFunction(upd) ? upd(curr) : upd;
};
